import React, { useState } from "react";
import { Modal, Button, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import * as api from "../utils/api";

const DeleteModal = ({
                       selectedEvent,
                       recurring,
                       deleteCustomEvent,
                       refreshEvents,
                       cancelModal,
                     }) => {
  const [deleteMode, setDeleteMode] = useState(1);

  const handleDelete = () => {
    if (recurring) {
      // recurring / multiple-delete flow
      if (selectedEvent.length > 1) {
        api.endpoints.deleteMultipleMeetups(
            null,
            selectedEvent,
            deleteMode,
            () => refreshEvents()
        );
      } else {
        // single recurring event
        deleteCustomEvent(selectedEvent[0], deleteMode);
      }
    } else {
      // simple, non-recurring custom event
      deleteCustomEvent(selectedEvent[0]);
    }
    cancelModal();
  };

  return (
      <Modal show centered onHide={cancelModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {recurring ? "Delete recurring event" : "Delete selected event"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          {recurring ? (
              <>
                <h4>Which event(s) do you want to delete?</h4>
                {selectedEvent.length > 1 && (
                    <p className="text-muted">
                      Be aware! Your choice will apply to all selected events.
                    </p>
                )}
                <ToggleButtonGroup
                    type="radio"
                    name="deleteEvents"
                    vertical
                    className="mt-3"
                    value={deleteMode}
                    onChange={(val) => setDeleteMode(val)}
                >
                  <ToggleButton value={1} variant="outline-primary">
                    This event
                  </ToggleButton>
                  <ToggleButton value={2} variant="outline-primary">
                    This and following events
                  </ToggleButton>
                  <ToggleButton value={3} variant="outline-primary">
                    All events
                  </ToggleButton>
                </ToggleButtonGroup>
              </>
          ) : (
              <p className="text-danger">
                ⚠️ Are you sure you want to delete this event?
                <br />
                This cannot be undone.
              </p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={cancelModal}>
            Cancel
          </Button>
          <Button
              variant={recurring ? "primary" : "danger"}
              onClick={handleDelete}
              disabled={recurring && deleteMode < 1}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
  );
};

export default DeleteModal;
